var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixMembersV1CustomFieldSuggestion from '@wix/ambassador-members-v1-custom-field-suggestion/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var Privacy;
(function (Privacy) {
    Privacy["UNKNOWN"] = "UNKNOWN";
    Privacy["PUBLIC"] = "PUBLIC";
    Privacy["PRIVATE"] = "PRIVATE";
})(Privacy || (Privacy = {}));
export var Type;
(function (Type) {
    Type["UNKNOWN"] = "UNKNOWN";
    Type["TEXT"] = "TEXT";
    Type["NUMBER"] = "NUMBER";
    Type["DATE"] = "DATE";
    Type["URL"] = "URL";
    Type["SOCIAL"] = "SOCIAL";
})(Type || (Type = {}));
export var SocialTypeType;
(function (SocialTypeType) {
    SocialTypeType["UNKNOWN"] = "UNKNOWN";
    SocialTypeType["FACEBOOK"] = "FACEBOOK";
    SocialTypeType["INSTAGRAM"] = "INSTAGRAM";
    SocialTypeType["LINKEDIN"] = "LINKEDIN";
    SocialTypeType["TWITTER"] = "TWITTER";
    SocialTypeType["YOUTUBE"] = "YOUTUBE";
    SocialTypeType["PINTEREST"] = "PINTEREST";
    SocialTypeType["TIKTOK"] = "TIKTOK";
    SocialTypeType["DEVIANTART"] = "DEVIANTART";
    SocialTypeType["SOUNDCLOUD"] = "SOUNDCLOUD";
    SocialTypeType["TUMBLR"] = "TUMBLR";
    SocialTypeType["VIMEO"] = "VIMEO";
    SocialTypeType["VKONTAKTE"] = "VKONTAKTE";
    SocialTypeType["ODNOKLASSNIKI"] = "ODNOKLASSNIKI";
    SocialTypeType["OTHER"] = "OTHER";
})(SocialTypeType || (SocialTypeType = {}));
export var Origin;
(function (Origin) {
    Origin["UNKNOWN"] = "UNKNOWN";
    Origin["CUSTOM"] = "CUSTOM";
    Origin["CONTACT"] = "CONTACT";
    Origin["SYSTEM"] = "SYSTEM";
})(Origin || (Origin = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
const _listCustomFieldSuggestionsRequest = {};
const _listCustomFieldSuggestionsResponse = {};
const _queryCustomFieldSuggestionsRequest = {};
const _queryCustomFieldSuggestionsResponse = {};
/**
 * Returns suggestions of custom fields to add.
 * @public
 * @documentationMaturity preview
 * @adminMethod
 */
export function listCustomFieldSuggestions(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            paging: '$[0].paging',
            sorting: '$[0].sorting',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listCustomFieldSuggestionsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listCustomFieldSuggestionsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#suggestions']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixMembersV1CustomFieldSuggestion.listCustomFieldSuggestions(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Returns suggestions of custom fields to add by specified type.
 * @public
 * @documentationMaturity preview
 * @adminMethod
 */
export function queryCustomFieldSuggestions(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { query: '$[0].query' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _queryCustomFieldSuggestionsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _queryCustomFieldSuggestionsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#suggestions']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixMembersV1CustomFieldSuggestion.queryCustomFieldSuggestions(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=members-v1-custom-field-suggestion.universal.js.map